<template>
  <div class="row px-4 justify-content-center">
    <h5 class="col-sm-12 text-center">{{ $t('supplies_prompt') }}</h5>
    <div class="form-group col-md-6 col-sm-12 text-center" data-aos="fade-right" data-aos-duration="1500" data-aos-delay="200">
      <image-uploader
        v-if="enabled"
        :attr="attrForField"
        :max-files="2"
        :url="url"
        :process-result="processUpload"
        :form-data="formData"
      ></image-uploader>
      <div class="row row-cols-1 row-cols-md-2">
        <generic-image v-for="image in images" :key="image.id" :image="image" />
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/cleaners/api'
import ImageUploader from '@/shared/uploaders/image.vue'
import GenericImage from '@/shared/generic_image.vue'
export default {
  components: {
    ImageUploader,
    GenericImage
  },
  props: {
    readonly: {
      type: Boolean,
      required: true
    },
    applicationId: {
      type: Number
    }
  },
  data() {
    return {
      images: [],
      imageContext: 'supplies',
      loading: true,
      uploadMode: null
    }
  },
  computed: {
    attrForField() {
      return {
        name: 'cleaner_application_image[image]',
        key: 'id'
      }
    },
    enabled() {
      return this.formData && (this.images.length < 2)
    },
    url() {
      return "/api/cleaner_application_images"
    },
    formData() {
      if (this.applicationId) {
        return {
          'cleaner_application_id': this.applicationId, context: this.imageContext
        }
      }
    },
  },
  mounted() {
    this.loadImages()
  },
  methods: {
    loadImages(opts = {}) {
      this.loading = true
      api.getApplicationImages(this.applicationId, this.imageContext).then(response => {
        this.images = response.data
        if (this.images.length > 1) {
          this.$emit('update', { supplies: true, noNext: opts.autoload })
        }
        this.loading = false
      }, error => {
        this.loading = false
        this.$flasher.error(error.response.data.errors)
      })
    },
    processUpload(result, key) {
      this.loadImages()
      return result
    }
  },
  watch: {
    applicationId(newValue) {
      if (newValue) {
        this.loadImages({ autoload:  true })
      }
    }
  }
}
</script>
